.modalContent {
    display: flex;
    flex-direction: column;
}

.dropzone {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 30px;
	border: 3px dashed var(--hps-gray);
}

.dropzone.disabled {
	opacity: 0.6;
}

.dropzone p {
	margin: 0;
}

.dropzoneDragActive {
	background-color: var(--hps-light-gray);
}
